export enum SignupStep {
  WAITING = "waiting",
  TERMS = "terms",
  PASSWORD = "password",
  PROFILE = "profile",
  SUCCESS = "success",
}
